import React from 'react';

import './mobile-msti-test-style.scss';

import MobileAppDownload from '@src/componentsNew/AppDownload/MobileAppDownload';

const MobileMstiTestPage = ({ deepLink }) => {
  return (
    <div id="mobile-msti-test-wrapper">
      <MobileAppDownload deepLink={deepLink} infoText="MSTI test can be taken on the Maccaron App" />
    </div>
  );
};

export default MobileMstiTestPage;
